import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2)
  },
  backButton: {
    marginTop: '10px'
  },
  description: {
    marginBottom: '10px'
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.primary.main
  },
  imagem: {
    maxWidth: 1000,
    maxHeight: 1000,
    width: '100%',
    height: 900
  }
}));
